module.exports = __webpack_public_path__ + "img/Packing_material_stock.5e215bc4.svg";